import { state } from './map_state/state'
import { viewport } from './map_state/viewport'

export const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v))

export const worldToScreen = (wx, wy) => {
  const [camX, camY] = viewport.getCamCoordinates()
  return {
    x: (wx - camX) * state.zoomValue,
    y: (wy - camY) * state.zoomValue
  }
}

export const screenToWorld = (clientX, clientY) => {
  const rect = viewport.canvas.getBoundingClientRect()
  const [camX, camY] = viewport.getCamCoordinates()
  const sx = clientX - rect.left
  const sy = clientY - rect.top

  return {
    x: (sx / state.zoomValue) + camX,
    y: (sy / state.zoomValue) + camY
  }
}

export const screenCssToWorld = (cssPoint) => {
  const [camX, camY] = viewport.getCamCoordinates()
  return {
    x: camX + cssPoint.x / state.zoomValue,
    y: camY + cssPoint.y / state.zoomValue
  }
}

export function canvasBackingToCss (p) {
  const rect = viewport.canvas.getBoundingClientRect()
  const scaleX = viewport.canvas.width / rect.width
  const scaleY = viewport.canvas.height / rect.height
  return { x: p.x / scaleX, y: p.y / scaleY }
}

export const callMethodOnKeydown = (target, method) => {
  const isTypingField =
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        target instanceof HTMLSelectElement ||
        target.isContentEditable

  if (isTypingField) return

  method()
}

export const getImageDimensions = () => {
  return {
    left: state.mapWorld.x,
    top: state.mapWorld.y,
    right: state.mapWorld.x + state.mapImage.naturalWidth,
    bottom: state.mapWorld.y + state.mapImage.naturalHeight
  }
}

export const hexToRgba = (hex, a) => {
  const h = (hex || '').replace('#', '')
  if (h.length !== 6) return `rgba(0,0,0,${a})`
  const r = parseInt(h.slice(0, 2), 16)
  const g = parseInt(h.slice(2, 4), 16)
  const b = parseInt(h.slice(4, 6), 16)
  return `rgba(${r},${g},${b},${a})`
}

export const getCanvasCursorPosition = (x, y) => {
  const rect = viewport.canvas.getBoundingClientRect()
  const world = screenCssToWorld({ x: x - rect.left, y: y - rect.top })
  const aabb = getImageDimensions()
  const inside = world.x >= aabb.left && world.x <= aabb.right && world.y >= aabb.top && world.y <= aabb.bottom
  return [world, aabb, inside]
}

export const keyMapping = (key, message) => `
    <div class="mct-key-container">
        <div class="mct-key">${key}</div>
        <div class="mct-action">${message}</div>
    </div>`

export const findSensorUnderCursor = (world) => {
  let best = null
  let bestDistance = Infinity
  const hitRadius = 12 / state.zoomValue

  state.sensors.forEach(sensor => {
    const distance = Math.hypot(world.x - sensor.position.x, world.y - sensor.position.y)
    if (distance <= hitRadius && distance < bestDistance) {
      best = sensor
      bestDistance = distance
    }
  })

  return best
}

export const isTyping = (target) => !!target?.closest('input, textarea, select, [contenteditable="true"], [contenteditable=""]')
